import React from "react";
import { ProviderAmazon } from './Providers/ProviderAmazon';

export const ProviderDistributor = (props) => {
  const getSpecificProvider = () => {
    switch (props.match.params.providerType) {
      case "amazon": {
        return <ProviderAmazon
          providerType={props.match.params.providerType}
        />;
      }

      default: {
        return <h2>Integration is unavailable</h2>;
      }
    }
  };

  return <div className="Dashboard__content">{getSpecificProvider()}</div>;
};
